import { render, staticRenderFns } from "./RequestDocuments.vue?vue&type=template&id=fbd283d4&scoped=true"
import script from "./RequestDocuments.vue?vue&type=script&lang=js"
export * from "./RequestDocuments.vue?vue&type=script&lang=js"
import style0 from "./RequestDocuments.vue?vue&type=style&index=0&id=fbd283d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd283d4",
  null
  
)

export default component.exports